import { SignoutForm } from '@ekhodealer/ekho-common/auth-client';

import { paths } from '@config/paths/index';

/**
 * Signout page - thin wrapper that composes the signout form component
 */
function SignoutPage() {
	return <SignoutForm redirectDestination={paths.login.getHref()} />;
}

export default SignoutPage;
